import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as _ from 'lodash';
import { ContentCardWrap } from 'components';
import { getCategoryContent } from 'redux/modules/contentLibraryContent';
import { connect } from 'react-redux';
var ContentCategory = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    categoryContent: state.contentLibraryContent.categoryContent,
    loadingCategoryContent: state.contentLibraryContent.loadingCategoryContent
  };
}, {
  getCategoryContent: getCategoryContent
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContentCategory, _Component);

  var _super = _createSuper(ContentCategory);

  function ContentCategory() {
    _classCallCheck(this, ContentCategory);

    return _super.apply(this, arguments);
  }

  _createClass(ContentCategory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // get the next chunk of content if category has more
      if (this.props.categoryContent && this.props.categoryContent[this.props.categorySlug] && this.props.categoryContent[this.props.categorySlug].data) {
        if (this.props.categoryContent[this.props.categorySlug].hasMore) {
          this.props.getCategoryContent(this.props.categorySlug, this.props.categoryContent[this.props.categorySlug].offset + this.props.categoryContent[this.props.categorySlug].limit);
        }
      } else {
        this.props.getCategoryContent(this.props.categorySlug);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.categorySlug !== this.props.categorySlug) {
        this.props.getCategoryContent(this.props.categorySlug);
      }
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement(ContentCardWrap, {
        queueRowHeight: this.props.queueRowHeight,
        starControl: this.props.starControl,
        queueControlArea: this.props.queueControlArea,
        handlePostCardClick: function handlePostCardClick(post) {
          _this.props.handlePostCardClick(post);
        },
        bucketDetailHeight: this.props.bucketDetailHeight,
        isBucketPage: this.props.isBucketPage,
        categoryName: this.props.categoryName,
        handleScroll: this.props.handleContentAreaScroll,
        data: this.props.categoryContent && this.props.categoryContent[this.props.categorySlug] && this.props.categoryContent[this.props.categorySlug].data ? this.props.categoryContent[this.props.categorySlug].data : [],
        hasMore: this.props.categoryContent && this.props.categoryContent[this.props.categorySlug] && this.props.categoryContent[this.props.categorySlug].hasMore ? this.props.categoryContent[this.props.categorySlug].hasMore : false,
        loading: this.props.loadingCategoryContent,
        loadMore: function loadMore() {
          if (!_this.props.loadingCategoryContent) {
            _this.props.getCategoryContent(_this.props.categorySlug, _this.props.categoryContent[_this.props.categorySlug].offset + _this.props.categoryContent[_this.props.categorySlug].limit);
          }
        }
      });
    }
  }]);

  return ContentCategory;
}(Component)) || _class);
ContentCategory.defaultProps = {
  isBucketPage: false
};
export default ContentCategory;